import {
  normalizeResponseError,
  normalizeThrownError,
} from '@/context/services/normalizeError';
import { isSuccess } from '@/context/services/type';
import { useBulkDestroyAdminInvoiceReports } from 'ap-openapi';
import { useCallback } from 'react';

export const useBulkDeleteAdminInvoiceReportService = () => {
  const { mutateAsync: _mutateAsync } = useBulkDestroyAdminInvoiceReports();

  const mutateAsync = useCallback(
    async (ids: string[]) => {
      try {
        const resp = await _mutateAsync({ data: { report_ids: ids } });

        if (isSuccess(resp.status)) {
          return { status: 'success' as const, data: resp.data };
        }

        return {
          status: 'error' as const,
          errors: normalizeResponseError(resp.status, resp.data),
        };
      } catch (error) {
        return {
          status: 'error' as const,
          errors: normalizeThrownError(error),
        };
      }
    },
    [_mutateAsync]
  );

  return { mutateAsync };
};
